"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getQuestProjectLabels = getQuestProjectLabels;
var Appdefs = window.cccisd.appDefs;
function getQuestProjectLabels() {
  var questProjectLabel = 'Quest Project';
  var questProjectLabelPlural = 'Quest Projects';
  try {
    questProjectLabel = Appdefs.pawn.groups.find(function (g) {
      return g.handle === 'questproject';
    }).label;
    questProjectLabelPlural = Appdefs.pawn.groups.find(function (g) {
      return g.handle === 'questproject';
    }).labelPlural;
  } catch (e) {
    // meh *shrug*
  }
  var questAdminLabel = 'Quest Admin';
  var questAdminLabelPlural = 'Quest Admins';
  try {
    questAdminLabel = Appdefs.pawn.roles.find(function (g) {
      return g.handle === 'questprojectadmin';
    }).label;
    questAdminLabelPlural = Appdefs.pawn.roles.find(function (g) {
      return g.handle === 'questprojectadmin';
    }).labelPlural;
  } catch (e) {
    // meh *shrug*
  }
  return {
    questProjectLabel: questProjectLabel,
    questProjectLabelPlural: questProjectLabelPlural,
    questAdminLabel: questAdminLabel,
    questAdminLabelPlural: questAdminLabelPlural
  };
}